<template>
  <div class="flex flex-1 menu_btm">
    <!-- 左侧增加了 bg-[#F5F5F5] -->
    <div class="flex w-[124px] flex-col left_menu bg-[#F5F5F5]">
      <div v-for="(item, index) in menuList" :key="index" class="w-full">
        <!-- 一级菜单 -->
        <div
          class="flex items-center justify-center h-16 group cursor-pointer"
          :class="[
            'relative text-center',
            'font-popM text-sm leading-4 font-medium',
            // 一级选中背景色 #fff，去除了多余的 before 竖线
            activeIndex1 === index ? 'bg-[#fff]' : '',
          ]"
          @click="handleLevel1Click(item, index)"
          v-gio-track="{
            event: 'clickNavigation',
            attrs: {
              pageCode_var: route.meta.pageCode,
              modulePosition_var: '顶部',
              moduleType_var: $t(item.title, {}, { locale: 'zh-CN' }),
              moduleName_var: '-',
              pageClickName_var: '-',
              $title: '-',
            },
          }"
        >
          <!-- 如果没有子分类，正常使用 NuxtLink 进行直接跳转 -->
          <NuxtLink
            v-if="!item.subCategories"
            v-track="{
              eventCode: 'MPERA.MENU.CLICK',
              extensions: {
                NAME: item.name,
                path: item.path,
                LANG: langPrefix,
              },
            }"
            :rel="item.link ? 'nofollow' : ''"
            :href="item.href"
            :to="item.path && !item.redirectAppId ? langPrefix + item.path : ''"
            class="w-full h-full flex items-center justify-center"
          >
            <span
              class="font-popM font-medium leading-4"
              :class="activeIndex1 === index ? 'text-[#333]' : 'text-paper'"
            >
              {{ $t(item.title) }}
            </span>
          </NuxtLink>

          <!-- 如果有子分类，仅作展开/折叠功能，不包裹 NuxtLink -->
          <div v-else class="w-full h-full flex items-center justify-center">
            <span
              class="font-popM font-medium leading-4"
              :class="activeIndex1 === index ? 'text-[#333]' : 'text-paper'"
            >
              {{ $t(item.title) }}
            </span>
          </div>
        </div>

        <!-- 二级菜单（当包含 subCategories 且当前一级菜单被选中时展开，加入丝滑动画） -->
        <div
          v-if="item.subCategories && item.subCategories.length > 0"
          class="grid transition-all duration-300 ease-in-out w-full bg-[#fff]"
          :class="
            activeIndex1 === index
              ? 'grid-rows-[1fr] pb-2'
              : 'grid-rows-[0fr] pb-0'
          "
        >
          <div class="overflow-hidden flex flex-col w-full">
            <div
              v-for="(subItem, subIndex) in item.subCategories"
              :key="subIndex"
              class="relative flex items-center justify-center h-10 cursor-pointer w-full"
              @click.stop="handleLevel2Click(subIndex)"
              v-gio-track="{
                event: 'clickNavigation',
                attrs: {
                  pageCode_var: route.meta.pageCode,
                  modulePosition_var: '顶部',
                  moduleType_var: $t(item.title, {}, { locale: 'zh-CN' }),
                  moduleName_var: '-',
                  pageClickName_var: $t(subItem.title, {}, { locale: 'zh-CN' }),
                  $title: '-',
                },
              }"
            >
              <span
                class="text-[13px] font-popR text-center"
                :class="
                  activeIndex2 === subIndex
                    ? 'text-[#FF6A00] font-semibold'
                    : 'text-[#232324]'
                "
              >
                {{ $t(subItem.title) }}
              </span>
              <!-- 二级选中时左侧宽2px的色块 -->
              <div
                v-if="activeIndex2 === subIndex"
                class="absolute left-0 top-0 w-[2px] h-full bg-[#FF6A00]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧菜单 -->
    <div class="flex-1 overflow-y-auto right_menu">
      <div class="flex flex-col right_content">
        <!-- 如果左侧有二级菜单展开，或设定了强制显示标题（如解决方案），则在右侧顶部显示一级标题 -->
        <div
          v-if="hasActiveSubCategories || currentLevel1ShowRightTitle"
          class="flex items-center w-full pb-[25px] pt-[16px] border-b border-[#E7E7E8]"
        >
          <span class="font-popSB font-semibold text-[15px] text-[#232324]">
            {{ $t(currentLevel1Title) }}
          </span>
        </div>

        <!-- 具体的子菜单列表 -->
        <div v-for="(subItem, subIndex) in currentRightList" :key="subIndex">
          <!-- 判断是否有三级菜单：有则渲染手风琴折叠效果 -->
          <div
            v-if="subItem.children && subItem.children.length > 0"
            class="flex flex-col"
          >
            <!-- 手风琴标题区域 -->
            <div
              class="relative flex items-center justify-between w-full pt-[16px] pb-[16px] cursor-pointer"
              @click="toggleRightAccordion(subIndex)"
            >
              <!-- 移除了原本动态变化的 text-[#FF6A00]，现固定为 text-[#232324] -->
              <span class="font-popl text-[15px] text-[#232324] font-medium">
                {{ $t(subItem.title) }}
              </span>
              <!-- 展开/收起 箭头 (带旋转与变色动画) -->
              <svg
                class="transition-transform duration-300"
                :class="
                  activeRightAccordionIndex === subIndex
                    ? 'rotate-180'
                    : 'rotate-0'
                "
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 4.5L6 8L9.5 4.5"
                  stroke="#232324"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <!-- 手风琴内容区域（三级菜单，加入高度展开动画） -->
            <div
              class="grid transition-all duration-300 ease-in-out w-full"
              :class="
                activeRightAccordionIndex === subIndex
                  ? 'grid-rows-[1fr] pb-[12px]'
                  : 'grid-rows-[0fr] pb-0'
              "
            >
              <div class="overflow-hidden flex flex-col space-y-2">
                <NuxtLink
                  v-for="(level3Item, level3Index) in filterByLang(
                    subItem.children,
                  )"
                  :key="level3Index"
                  v-track="{
                    eventCode: 'MPERA.MENU.CLICK',
                    extensions: {
                      NAME: level3Item.name,
                      path: level3Item.path,
                      LANG: langPrefix,
                    },
                  }"
                  :rel="level3Item.link ? 'nofollow' : ''"
                  :to="
                    level3Item.redirectAppId
                      ? ''
                      : level3Item.path
                        ? langPrefix + level3Item.path
                        : level3Item.link
                          ? level3Item.link + `?lang=${langPrefix}`
                          : ''
                  "
                  class="pl-1 font-[Poppins-Regular] flex items-center justify-start"
                  v-gio-track="{
                    event: 'clickNavigation',
                    attrs: {
                      pageCode_var: route.meta.pageCode,
                      modulePosition_var: '顶部',
                      moduleType_var: $t(
                        menuList[activeIndex1]?.title || '',
                        {},
                        { locale: 'zh-CN' },
                      ),
                      moduleName_var:
                        $t(subItem?.title || '', {}, { locale: 'zh-CN' }) ||
                        '-',
                      pageClickName_var: $t(
                        level3Item.title,
                        {},
                        { locale: 'zh-CN' },
                      ),
                      $title: '-',
                    },
                  }"
                  @click="clickSubIndex(level3Item)"
                >
                  <!-- 增加了选中变色逻辑 -->
                  <span
                    class="font-popR text-[14px] pt-[16px] pb-[16px] pl-[16px]"
                    :class="
                      activeRightItemName ===
                      (level3Item.name || level3Item.title)
                        ? 'text-[#FF6A00] font-semibold'
                        : 'text-[#232324]'
                    "
                  >
                    {{ $t(level3Item.title) }}
                  </span>
                </NuxtLink>
              </div>
            </div>
          </div>

          <!-- 没有三级菜单：正常渲染原先的直连模式 -->
          <NuxtLink
            v-else
            v-track="{
              eventCode: 'MPERA.MENU.CLICK',
              extensions: {
                NAME: subItem.name,
                path: subItem.path,
                LANG: langPrefix,
              },
            }"
            :rel="subItem.link ? 'nofollow' : ''"
            :to="
              subItem.redirectAppId
                ? ''
                : subItem.path
                  ? langPrefix + subItem.path
                  : subItem.link + `?lang=${langPrefix}`
            "
            class="font-[Poppins-Regular] flex flex-col justify-center items-start border-b border-[#F5F5F5] last:border-none"
            v-gio-track="{
              event: 'clickNavigation',
              attrs: {
                pageCode_var: route.meta.pageCode,
                modulePosition_var: '顶部',
                moduleType_var: $t(
                  menuList[activeIndex1]?.title || '',
                  {},
                  { locale: 'zh-CN' },
                ),
                moduleName_var:
                  $t(currentLevel2Title || '', {}, { locale: 'zh-CN' }) || '-',
                pageClickName_var: $t(subItem.title, {}, { locale: 'zh-CN' }),
                $title: '-',
              },
            }"
            @click="clickSubIndex(subItem)"
          >
            <div class="flex items-center w-full pt-[16px] pb-[16px]">
              <!-- 这里也同步增加了点击选中变色效果 -->
              <span
                class="font-popl text-[15px] text-center"
                :class="
                  activeRightItemName === (subItem.name || subItem.title)
                    ? 'text-[#FF6A00] font-semibold'
                    : 'text-[#232324] font-medium'
                "
              >
                {{ $t(subItem.title) }}
              </span>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue'

  const activeIndex1 = ref(-1) // 改成默认不选中
  const activeIndex2 = ref(-1) // 二级菜单的选中状态
  const activeRightAccordionIndex = ref(-1) // 右侧存在三级菜单时，手风琴的折叠状态
  const activeRightItemName = ref('') // 记录当前点击高亮的右侧三级菜单（或独立二级菜单）

  const menuList = ref<any>([])
  const route = useRoute()

  const systemStore = useMySystemStore()

  const langPrefix = computed(() => {
    return systemStore.language === 'en-US' ? '/en' : '/cn'
  })

  // 过滤中英文下特定的项
  const filterByLang = (list: any[]) => {
    if (systemStore.language === 'en-US') {
      return list.filter((child: any) => !child.hideInEn)
    }
    return list
  }
  const currentLevel2Title = computed(() => {
    if (activeIndex1.value < 0 || activeIndex2.value < 0) {
      return ''
    }
    const list = menuList.value[activeIndex1.value]
    if (!list) return ''
    return list.subCategories[activeIndex2.value]?.title || ''
  })
  // 获取当前选中一级菜单的标题
  const currentLevel1Title = computed(() => {
    if (activeIndex1.value === -1) return ''
    return menuList.value[activeIndex1.value]?.title || ''
  })

  // 获取当前的一级菜单是否要求右侧强制显示标题
  const currentLevel1ShowRightTitle = computed(() => {
    if (activeIndex1.value === -1) return false
    return menuList.value[activeIndex1.value]?.showRightTitle || false
  })

  // 判断当前选中的一级菜单是否包含并且展开了二级菜单
  const hasActiveSubCategories = computed(() => {
    if (activeIndex1.value === -1) return false
    const item = menuList.value[activeIndex1.value]
    return item && item.subCategories && item.subCategories.length > 0
  })

  // 根据当前选中的左侧层级，动态计算右侧该显示什么内容
  const currentRightList = computed(() => {
    if (activeIndex1.value === -1) return []
    const item = menuList.value[activeIndex1.value]

    let rawList = []
    // 如果存在左侧的二级类目
    if (item.subCategories && item.subCategories.length > 0) {
      if (activeIndex2.value !== -1 && item.subCategories[activeIndex2.value]) {
        rawList = item.subCategories[activeIndex2.value].children || []
      }
    } else {
      // 如果没有二级类目，直接展示该项的 children
      rawList = item.children || []
    }

    return filterByLang(rawList)
  })

  // Note: 'title' 字段尽量配置成你们对应的多语言 i18n 键，此处新加的默认填入字面量方便直观展示
  const list = [
    {
      name: 'Company Directory',
      path: '/company/',
      title: 'home.header.CompanyDirectory',
    },
    {
      name: 'Global Events',
      title: 'home.header.NewEvent.name',
      subCategories: [
        {
          name: 'Event',
          title: 'home.header.NewEvent.action',
          children: [
            {
              redirectAppId: 'MPERA',
              name: 'Event',
              path: '/event-conference/',
              title: 'home.header.NewEvent.allYearEvent',
            },
            {
              redirectAppId: 'MPERA',
              name: 'Regional Conference',
              path: '/event-conference/',
              title: 'home.header.NewEvent.RegionalEvent',
            },
            {
              redirectAppId: 'MPERA',
              name: 'Co-exhibition',
              path: '/event-conference/',
              title: 'home.header.NewEvent.exhibition',
            },
          ],
        },
        {
          name: 'Academy',
          title: 'home.header.NewEvent.Academy',
          children: [
            {
              redirectAppId: 'MPERA',
              name: 'Member Success',
              path: '/academy/',
              title: 'home.header.Solutions.memberSuccess',
            },
            {
              redirectAppId: 'MPERA',
              name: 'JCtrans Connect+',
              path: '/academy/',
              title: 'JCtrans Connect+',
            },
            {
              redirectAppId: 'MPERA',
              name: 'JCtrans Salon',
              path: '/academy/',
              title: 'home.header.Solutions.salon',
            },
          ],
        },
      ],
    },
    {
      name: 'Cooperation Risk Protection',
      title: 'home.header.Risk.name',
      subCategories: [
        {
          name: 'Risk Protection',
          title: 'home.header.Risk.protection',
          children: [
            {
              name: 'Risk Member List',
              path: '/membership/tools/risk/blackList',
              title: 'home.header.Risk.member',
            },
            {
              name: 'Risk Prevention',
              path: '/membership/tools/riskPrevention/case',
              title: 'home.header.Risk.prevention',
            },
            {
              name: 'Assurance Introduction',
              path: '/membership/tools/assurance/process',
              title: 'home.header.Risk.introduction',
            },
          ],
        },
        {
          name: 'JC Insurance',
          title: 'home.header.Risk.JCinsurance',
          children: [
            {
              name: 'Cargo Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.insurance',
            },
            {
              name: 'Forwarder Liability Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.liability',
            },
          ],
        },
        {
          name: 'Credit Assurance Order',
          title: 'home.header.Risk.assurance',
          children: [
            {
              name: 'Trade Order',
              path: '/marketing/transaction/',
              title: 'home.header.Risk.transaction',
            },
            {
              name: 'Credit Assurance Order',
              path: '/marketing/credit/',
              title: 'home.header.Risk.order',
            },
          ],
        },
      ],
    },
    {
      name: 'JC Pay',
      title: 'JC Pay',
      children: [
        {
          name: 'Settlement between members',
          path: '/finance-jcpay/',
          title: 'home.header.JCPay.settlement',
        },
        {
          name: 'Domestic USD Payment',
          path: '/finance-usd/',
          title: '国内美元支付',
          hideInEn: true,
        },
      ],
    },
    {
      name: 'Hot Products',
      title: 'home.header.newProducts.name',
      subCategories: [
        {
          name: 'Membership',
          title: 'home.header.newProducts.Membership',
          children: [
            {
              name: 'General Membership',
              path: '/vip/#general',
              title: 'home.header.newProducts.general',
            },
            {
              name: 'Specialty Membership',
              path: '/vip/#specialty',
              title: 'home.header.newProducts.specialty',
            },
            {
              name: 'Supplier Service',
              path: '/vip/#vendor',
              title: 'home.header.newProducts.vendor',
            },
            {
              name: 'JC Verified',
              path: '/JCVerified/',
              title: 'JC Verified',
            },
          ],
        },
        {
          name: 'Event',
          title: 'home.header.NewEvent.action',
          children: [
            {
              redirectAppId: 'MPERA',
              name: 'Event',
              path: '/event-conference/',
              title: 'home.header.NewEvent.allYearEvent',
            },
            {
              redirectAppId: 'MPERA',
              name: 'Regional Conference',
              path: '/event-conference/',
              title: 'home.header.NewEvent.RegionalEvent',
            },
            {
              redirectAppId: 'MPERA',
              name: 'Co-exhibition',
              path: '/event-conference/',
              title: 'home.header.NewEvent.exhibition',
            },
          ],
        },
        {
          name: 'JC Pay',
          title: 'JC Pay',
          children: [
            {
              name: 'Settlement between members',
              path: '/finance-jcpay/',
              title: 'home.header.JCPay.settlement',
            },
            {
              name: 'Domestic USD Payment',
              path: '/finance-usd/',
              title: '国内美元支付',
              hideInEn: true,
            },
          ],
        },
        {
          name: 'JC Insurance',
          title: 'home.header.Risk.JCinsurance',
          children: [
            {
              name: 'Cargo Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.insurance',
            },
            {
              name: 'Forwarder Liability Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.liability',
            },
          ],
        },
      ],
    },
    // ================== 新增：解决方案 ==================
    {
      name: 'Solutions',
      title: 'home.header.Solutions.name',
      showRightTitle: true, // 控制无左侧二级菜单时，依旧在右侧顶部渲染标题
      children: [
        {
          title: 'home.header.Solutions.Business',
          children: [
            {
              name: 'Company Directory',
              path: '/company/',
              title: 'home.header.CompanyDirectory',
            },
            {
              name: 'Customer Management',
              path: '/client/',
              title: 'home.header.CustomerManagement',
            },
          ],
        },
        {
          title: 'home.header.Solutions.Risk',
          children: [
            {
              name: 'Risk Member List',
              path: '/membership/tools/risk/blackList',
              title: 'home.header.Risk.member',
            },
            {
              name: 'Risk Prevention',
              path: '/membership/tools/riskPrevention/case',
              title: 'home.header.Risk.prevention',
            },
            {
              name: 'Assurance Introduction',
              path: '/membership/tools/assurance/process',
              title: 'home.header.Risk.introduction',
            },
          ],
        },
        {
          title: 'home.header.Solutions.Payment',
          children: [
            {
              name: 'Domestic USD Payment',
              path: '/finance-usd/',
              title: '国内美元支付',
              hideInEn: true,
            },
            {
              name: 'Settlement between members',
              path: '/finance-jcpay/',
              title: 'home.header.JCPay.settlement',
            },
          ],
        },
        {
          title: 'home.header.Solutions.Academy',
          children: [
            {
              redirectAppId: 'MPERA',
              name: 'Member Success',
              path: '/academy/',
              title: 'home.header.Solutions.memberSuccess',
            },
            {
              redirectAppId: 'MPERA',
              name: 'JCtrans Connect+',
              path: '/academy/',
              title: 'JCtrans Connect+',
            },
            {
              redirectAppId: 'MPERA',
              name: 'JCtrans Salon',
              path: '/academy/',
              title: 'home.header.Solutions.salon',
            },
          ],
        },
        // {
        //   title: 'home.header.Solutions.Club',
        //   children: [
        //     {
        //       name: 'JC Club',
        //       path: '',
        //       title: 'home.header.Solutions.JCclub',
        //       appId: 'CLUB',
        //       link: 'https://mclub.jctrans.com/',
        //     },
        //   ],
        // },
        {
          title: 'home.header.Solutions.Cargo',
          children: [
            {
              name: 'Cargo Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.insurance',
            },
            {
              name: 'Forwarder Liability Insurance',
              path: '/JCInsurance/',
              title: 'home.header.Risk.liability',
            },
          ],
        },
        {
          title: 'home.header.Solutions.Credit',
          children: [
            {
              name: 'Trade Order',
              path: '/marketing/transaction/',
              title: 'home.header.Risk.transaction',
            },
            {
              name: 'Credit Assurance Order',
              path: '/marketing/credit/',
              title: 'home.header.Risk.order',
            },
          ],
        },
        {
          title: 'home.header.Solutions.Resources',
          children: [
            {
              name: 'JCtrans News',
              path: '/jctransnews/',
              title: 'home.header.newResources.JCnews',
            },
            {
              name: 'Logistics News',
              path: '/news/',
              title: 'home.header.newResources.Logistics',
            },
            {
              name: 'Freight Experience',
              path: '/news-experience/',
              title: 'home.header.newResources.Experience',
            },
            {
              name: 'Freight Area',
              path: '/news-regions/',
              title: 'home.header.newResources.Area',
            },
            {
              name: 'Freight Policy',
              path: '/news-policy/',
              title: 'home.header.newResources.Policy',
            },
            {
              name: 'Freight Solutions',
              path: '/news-solutions/',
              title: 'home.header.newResources.Solutions',
            },
            {
              name: 'Freight Knowledge',
              path: '/news-knowledge/',
              title: 'home.header.newResources.Knowledge',
            },
            {
              name: 'Success Story',
              path: '/successstory/',
              title: 'home.header.newResources.Story',
            },
            {
              name: 'Knowledge Share',
              path: '/blog/',
              title: 'home.header.newResources.Blog',
            },
          ],
        },
      ],
    },
    // ===================================================
    {
      name: 'About Us',
      title: 'home.header.Company.AboutUs',
      path: '/aboutus/',
    },
  ]

  menuList.value = list.map((item, index) => {
    return {
      code: index + 1,
      ...item,
    }
  })

  // 处理一级菜单点击
  function handleLevel1Click(item: any, index: number) {
    activeIndex1.value = index
    activeRightAccordionIndex.value = 0 // 切换一级菜单时，默认展开右侧的第一个手风琴结构
    activeRightItemName.value = '' // 清除右侧选项的高亮状态

    // 有左侧二级 或 右侧直接 children（如解决方案 / JC Pay）→ 只展开，不关菜单
    if (item.subCategories && item.subCategories.length > 0) {
      activeIndex2.value = 0
      return
    }
    if (item.children && item.children.length > 0) {
      activeIndex2.value = -1
      return
    }

    activeIndex2.value = -1
    // 无子集的一级：真正跳转时再关菜单
    triggerNavigation(item)
  }

  // 处理二级菜单点击
  function handleLevel2Click(subIndex: number) {
    activeIndex2.value = subIndex
    activeRightAccordionIndex.value = 0 // 切换左侧二级菜单时，同样重置右侧第一个手风琴为展开状态
    activeRightItemName.value = '' // 清除右侧选项的高亮状态
  }

  // 处理右侧菜单手风琴展开与收起
  function toggleRightAccordion(index: number) {
    if (activeRightAccordionIndex.value === index) {
      activeRightAccordionIndex.value = -1 // 若已打开则关掉
    } else {
      activeRightAccordionIndex.value = index // 打开新的
    }
  }

  // 点击具体的跳转项（三级菜单或无子集的二级菜单）
  const clickSubIndex = (item: any) => {
    activeRightItemName.value = item.name || item.title // 记录高亮状态
    triggerNavigation(item)
  }

  // 抽离公共的第三方链接与 APP 页面跳转逻辑
  function triggerNavigation(item: any) {
    if (item.redirectAppId) {
      systemStore.closeHeaderPopup()
      openPageByAppId(
        item.redirectAppId,
        item.path && langPrefix.value + item.path,
        '_self',
      )
      return
    }
    if (item.appId) {
      systemStore.closeHeaderPopup()
      openPageByAppId(item.appId)
      return
    }
    if (item.link) {
      systemStore.closeHeaderPopup()
      openByLink(item.link + `?lang=${langPrefix.value}`, '_target')
      return
    }
    // 普通 path 跳转也关菜单（同 path 仅 hash 变化时中间件不会关）
    // 无 path 的一级展开项（如解决方案）不关
    if (item.path) {
      systemStore.closeHeaderPopup()
    }
  }
</script>

<style lang="scss" scoped>
  .menu_btm {
    height: calc(100% - 200px);
    border-bottom: 1px solid #e7e7e8;

    .left_menu {
      width: 29.22%;
      height: 100%;
      overflow-y: auto; /* 建议将 scroll 改为 auto 体验更好 */
      border-right: 1px solid #edeff2;
    }

    .right_menu {
      width: 70.78%;
      height: 100%;
      .right_content {
        padding: 0 16px;
      }
    }
  }
</style>
